import { render, staticRenderFns } from "./TaxLiability.vue?vue&type=template&id=36e3c3d0&scoped=true&"
import script from "./TaxLiability.vue?vue&type=script&lang=ts&"
export * from "./TaxLiability.vue?vue&type=script&lang=ts&"
import style0 from "./TaxLiability.vue?vue&type=style&index=0&id=36e3c3d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e3c3d0",
  null
  
)

export default component.exports